<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-10">
          <h1 class="title">{{ $translate(title) | capitalize }}</h1>
        </div>
        <div class="column has-text-right"></div>
      </div>
      <b-field v-if="hasMoreCatalogs" horizontal :label="$translate('type') | capitalize">
        <b-select v-model="id" :placeholder="$translate('catalog_select')" @input="loadDatatoEdit(id)">
          <option :value="null"> </option>
          <option v-for="option in type" :key="option.id" :value="option.id">
            {{ option.name }}
          </option>
        </b-select>
      </b-field>
      <b-field horizontal :label="$translate('name') | capitalize">
        <b-input v-model="catalog.name" :disabled="permissionDenied"></b-input>
      </b-field>

      <b-tabs>
        <b-tab-item :label="$translate('materials') | capitalize">
          <h1 class="title">
            {{ $translate('materials') | capitalize }}
          </h1>
          <b-tabs vertical>
            <b-tab-item
              v-for="material in moduleMaterials"
              :key="material"
              :label="$translate(material) | capitalize"
              :materialtext="material"
            >
              <GeneralTableMaterialCustomer ref="MaterialTable" :module="catalog.type" :materialtext="material" />
            </b-tab-item>
          </b-tabs>
        </b-tab-item>
        <b-tab-item :label="$translate('models') | capitalize">
          <h1 class="title">
            {{ $translate('models') | capitalize }}
          </h1>
          <ModelsCatalogCustomer ref="ModelsCatalogCustomer" :key="id" :catalog="catalog" />
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import GeneralTableMaterialCustomer from './components/GeneralTableMaterialCustomer'
import ModelsCatalogCustomer from './components/ModelsCatalogCustomer'
import permissionMixin from '@/helpers/mixins/permissionMixin'

export default {
  name: 'CustomerCatalogs',
  components: {
    GeneralTableMaterialCustomer,
    ModelsCatalogCustomer,
  },
  mixins: [permissionMixin],
  data() {
    return {
      id: null,
      title: null,
      permissionDenied: false,
      realmodelcatalog: [],
      companies: [],
      moduleMaterials: [],
      catalog: {
        companyId: null,
        material: {},
        model: {},
      },
      type: [],
    }
  },
  computed: {
    hasMoreCatalogs() {
      return this.type.length > 1
    },
  },
  async mounted() {
    let isAllowed = false
    switch (this.userInfo.type) {
      case 'C':
        isAllowed = true
        this.permissionDenied = true
        break
    }
    if (!isAllowed) this.$router.push('/forbidden')

    await this.$db
      .collection('companies')
      .doc(this.$store.getters.user.userInfo.companyId)
      .get()
      .then(doc => {
        let newcomp = doc.data()
        newcomp.id = doc.id
        if (newcomp.catalog) {
          this.type.push({ name: this.$translate('tailored'), id: newcomp.catalog })
        }
        if (newcomp.catalog_fits) {
          this.type.push({ name: this.$translate('fits'), id: newcomp.catalog_fits })
        }
        if (newcomp.catalog_modular) {
          this.type.push({ name: this.$translate('modular'), id: newcomp.catalog_modular })
        }
        if (newcomp.catalog_insole) {
          this.type.push({ name: this.$translate('insole'), id: newcomp.catalog_insole })
        }
        if (this.type.length === 1) {
          this.loadDatatoEdit(this.type[0].id)
        }
      })

    if (this.type.length <= 0) {
      this.$router.push('/forbidden')
    }
  },
  methods: {
    loadDatatoEdit(id) {
      if (id) {
        this.$db
          .collection('catalogs')
          .doc(id)
          .get()
          .then(doc => {
            this.catalog = doc.data()
            this.moduleMaterials = this.$availableMaterials[this.catalog.type]
            this.$nextTick(() => {
              this.$refs.MaterialTable.forEach(temp => {
                temp.loadAsyncData(this.catalog)
              })
              switch (this.catalog.type) {
                case 'tailored':
                  this.$refs.ModelsCatalogCustomer.loadAsyncDataTailored(this.catalog)
                  break
                case 'fits':
                  this.$refs.ModelsCatalogCustomer.loadAsyncDataFits(this.catalog)
                  break
                case 'modular':
                  this.$refs.ModelsCatalogCustomer.loadAsyncDataModular(this.catalog)
                  break
                case 'insole':
                  this.$refs.ModelsCatalogCustomer.loadAsyncDataInsole(this.catalog)
                  break
              }
            })
          })
      } else {
        this.catalog = {}
        this.$refs.ModelsCatalogCustomer.resetTable()
        this.$refs.MaterialTable.forEach(temp => {
          temp.resetTable()
        })
      }
    },
  },
}
</script>
